/**
 * Ryan O'Dowd
 * 2024-02-08
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import React, {
} from 'react';
import Text from '@components/common/Text';
import {
  View,
} from 'react-native';
import getStyles from './styles';
import hooks from '@hooks';

const Lecture = (props: LectureProps) => {
  const styles = hooks.useStyles(getStyles);

  return (
    <View style={styles.container}>
      <Text style={styles.text}>{props.text}</Text>{/* @TODO: if contains link, make it an href */}
    </View>
  );
};

class LectureProps {
  id: number;
  // @TODO: created_at: string; // @TODO: date object?
  // @TODO: updated_at: string; // @TODO: date object?
  text: string; // @TODO: node? should allow for html or other markup
};

export default Lecture;
